// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"7d9e8d525d0320d27785","691":"fa662ac5bb9eb7d1059a"}[chunkId] + ".js";
};